import './footer.css';
  
  function Footer() {
    return (
        <section className="footer">
        <p>
        &copy; Copyright 2026 Greater Potential Physio. All Rights Reserved.
        </p>
      </section>
    );
  }
  
  export default Footer;
  